// useSeitenaufruf.js
// -------------------------------------------------------------------------
// Meldet einen Seitenaufruf an das Pipeline CRM. Einmal pro Mount aufrufen.
//
// Einbau in eine Seite:
//     import { useSeitenaufruf } from "@/hooks/useSeitenaufruf";
//     ...
//     useSeitenaufruf("seminar");
//
// Bewusst fehlertolerant: wenn das Tracking scheitert, merkt die Seite nichts
// davon. Ein kaputter Zaehler darf niemals eine Anmeldung verhindern.
//
// Der Sitzungsschluessel ist derselbe wie im Snippet der statischen
// Seminarseite (public/seminar.html) — sonst zaehlt derselbe Besucher je
// nach Seite unter zwei verschiedenen Sitzungs-IDs.
// -------------------------------------------------------------------------

import { useEffect, useRef } from "react";

const SITZUNG_SCHLUESSEL = "p1_sitzung";

function sitzungId() {
  try {
    let id = sessionStorage.getItem(SITZUNG_SCHLUESSEL);
    if (!id) {
      id =
        typeof crypto !== "undefined" && crypto.randomUUID
          ? crypto.randomUUID()
          : Math.random().toString(36).slice(2) + Date.now().toString(36);
      sessionStorage.setItem(SITZUNG_SCHLUESSEL, id);
    }
    return id;
  } catch {
    // Privater Modus o. ae. — dann eben eine Einweg-ID pro Aufruf
    return Math.random().toString(36).slice(2) + Date.now().toString(36);
  }
}

export function useSeitenaufruf(seite) {
  const gemeldet = useRef(false);

  useEffect(() => {
    if (gemeldet.current) return; // React StrictMode feuert Effects doppelt
    gemeldet.current = true;

    const params = new URLSearchParams(window.location.search);

    fetch("/api/public/tracking/aufruf", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      keepalive: true,
      body: JSON.stringify({
        seite,
        sitzung_id: sitzungId(),
        referrer: document.referrer || null,
        utm_source: params.get("utm_source"),
        utm_medium: params.get("utm_medium"),
        utm_campaign: params.get("utm_campaign"),
      }),
    }).catch(() => {
      /* bewusst still */
    });
  }, [seite]);
}
